import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const ActionPlanStatsChart = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-6">
      {/* Summary Cards */}
      <Card className="glass border-gray-200">
        <CardHeader>
          <CardTitle className="text-lg sm:text-xl">Plans Overview</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div className="flex justify-between items-center p-3 bg-brand-accent-soft rounded-lg">
              <span className="text-sm sm:text-base font-medium text-gray-700">Active Plans</span>
              <span className="text-xl sm:text-2xl font-bold text-brand-accent">{stats.plans.active}</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-green-50 rounded-lg">
              <span className="text-sm sm:text-base font-medium text-gray-700">Closed Plans</span>
              <span className="text-xl sm:text-2xl font-bold text-green-600">{stats.plans.closed}</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
              <span className="text-sm sm:text-base font-medium text-gray-700">Total Plans</span>
              <span className="text-xl sm:text-2xl font-bold text-gray-900">{stats.plans.total}</span>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="glass border-gray-200">
        <CardHeader>
          <CardTitle className="text-lg sm:text-xl">Tasks Overview</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div className="flex justify-between items-center p-3 bg-brand-accent-soft rounded-lg">
              <span className="text-sm sm:text-base font-medium text-gray-700">Completed Tasks</span>
              <span className="text-xl sm:text-2xl font-bold text-brand-accent">{stats.tasks.completed}</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-amber-50 rounded-lg">
              <span className="text-sm sm:text-base font-medium text-gray-700">Incomplete Tasks</span>
              <span className="text-xl sm:text-2xl font-bold text-amber-600">{stats.tasks.incomplete}</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
              <span className="text-sm sm:text-base font-medium text-gray-700">Total Tasks</span>
              <span className="text-xl sm:text-2xl font-bold text-gray-900">{stats.tasks.total}</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ActionPlanStatsChart;
